// @format

import "jquery";
import { Turbo, cable } from "@hotwired/turbo-rails";
import Chartkick from "chartkick";
import Chart from "chart.js/auto";
// Chart.defaults.global.defaultFontColor = "#ccc";
import RailsUJS from "@rails/ujs";
import "chartkick/chart.js"

RailsUJS.start();
Turbo.start();

window["Chartkick"] = Chartkick;
window["Turbo"] = Turbo;

import { initBotsProspectsGrid } from "../js/grid";
import {initBotsProspectReplyModal, initPaginationLimitButtons, initBotsProspectProfileModal, initCandidateDashboardSearchInput} from "../js/bots_prospect";
import { initHeader } from "../js/header";
import { initSubmitOnChange } from "../js/submit_on_change";
import { initChoices } from "../js/choices";
import {
	initEmailResponses,
	initFullThreadEmailResponses,
} from "../js/email_responses";
import { initCRMHiddenListener } from "../js/crm";
import { initContacted } from "../js/contacted";
import { initLoginForm } from "../js/log_in";
import { initNotes } from "../js/notes";
import { initLitepicker } from "../js/litepicker";
import {
	initProspectToggle,
	initEditProspectListener,
	initPhoneCompletedListener,
	initEmailsReceived,
	initRejectReasonListener,
	initReApproachedBtn,
	initCheckedBotsProspect,
	initBotProspectHistory,
	initPersonalizedMessage,
	initFetchPhoneButton,
	initSendConnectionRequestLinkedInModal,
	initWriteWithAIButton,
	initStatusCallingDropdown
} from "../js/prospect";
import { initTooltips } from "../js/tooltip";
import { initToggle } from "../js/toggle";
import { initTeamtailor } from "../js/teamtailor";
import { initAirtable } from "../js/airtable";
import { initDatePicker } from "../js/date_picker";
import { initScheduleDate } from "../js/schedule_date";
import { initQlfrModal, initAiSequenceModal } from "../js/qlfr_modal";
import { initSearchPreviews } from "../js/search_previews";
import { initLanguagePicker } from "../js/language_picker";
import { initFront } from "../js/front";
import { initSelectpicker, destroySelectpicker } from "../js/selectpicker";
import { initCustomSelect } from "../js/custom_select";
import { initDestroySequenceListener, initSequence } from "../js/sequences";
import { initDestroyBotListener, initShowSequences } from "../js/bots";
import { initDisconnectMailListener } from "../js/users";
import {
	initSummernote,
	destroySummernote,
	initOptOutSetter,
	checkOptOutPresence,
} from "../js/summernote";
import { initCommentSidebar } from "../js/comment_sidebar";
import { initHomeBanner } from "../js/home_banner";
import { initAutosize } from "../js/textarea";
import { initTimeZone } from "../js/time_zone";
import { initOverview } from "../js/overview";
import { initUserCompanies } from "../js/user_companies";
import { initCsvSelectsListener } from "../js/csv_data_import";
import { initCreditBatches } from "../js/credit_batches";
import { initClipCopy } from "../js/clip_copy";
import { initNotifier } from "../js/notifier";
import { initFileUpload } from "../js/file_upload";
import { initHubspot } from "../js/hubspot";
import { initMetaAdSearch, initCreativeTypeSelect } from "../js/meta_api"
import { initDrawer } from "../js/drawer";
import { initNoteDrawer } from "../js/note_drawer";
import { initToggleStatusHubspot } from "../js/toggle_status_hubspot";
import { initHubspotCompanySelect, initApiLogoSelect, initCustomersTable } from "../js/cs_dashboard";

// css
import "choices.js/assets/styles/css/choices.min.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap-select/dist/css/bootstrap-select.min.css";
import "bootstrap-datepicker/dist/css/bootstrap-datepicker.min.css";
import "summernote/dist/summernote-bs4.css";
import "../application.scss";

$(document).on("turbo:load", function (event) {
	initSearchPreviews();
});

$(document).on("turbo:load turbo:render", function (event) {
	window.scrollTo(0, 0); // force scroll to top at all times
	initLitepicker();
	initToggle();
	initAutosize();
	initHeader();
	initChoices();
	initTooltips();
	initHubspot();
	initCommentSidebar();
	initCRMHiddenListener();
	initLoginForm();
	initEmailResponses();
	initCheckedBotsProspect();
	initOverview();
	initTimeZone();
	initNotes();
	initContacted();
	initTeamtailor();
	initAirtable();
	initSelectpicker();
	initCustomSelect();
	initSequence();
	initSummernote();
	initClipCopy();
	initUserCompanies();
	initCsvSelectsListener();
	initCreditBatches();
	initNotifier();
	initFileUpload();
	initDatePicker();
	initScheduleDate();
	initQlfrModal();
	initAiSequenceModal();
	//initOptOutSetter();
	checkOptOutPresence();
	initFront();
  initFullThreadEmailResponses();
	setBudgetFieldsVisibility();
	initMetaAdSearch();
	initCreativeTypeSelect();
	initRenderCsStats();
  	initHubspotCompanySelect();
  	initApiLogoSelect();
	initDrawer();
	initNoteDrawer();
  initFetchPhoneButton();
	initToggleStatusHubspot();
  initConfirmationPopup();
});

initHomeBanner();
initProspectToggle();
initLanguagePicker();
initEditProspectListener();
initPhoneCompletedListener();
initDestroyBotListener();
initDisconnectMailListener();
initShowSequences();
initDestroySequenceListener();
initEmailsReceived();
initReApproachedBtn();
initRejectReasonListener();
initFullThreadEmailResponses();
initSubmitOnChange();
initBotProspectHistory();
initPersonalizedMessage();
initDrawer();
initNoteDrawer();
initSendConnectionRequestLinkedInModal();
initWriteWithAIButton();
initToggleStatusHubspot();
initCustomersTable();

$(document).on("render_async_load", () => {
	initBotsProspectsGrid();
	initBotsProspectReplyModal();
	initBotsProspectProfileModal();
	initPaginationLimitButtons();
	initSelectpicker();
	initClipCopy();
	initFullThreadEmailResponses();
	initPersonalizedMessage();
	initDrawer();
	initNoteDrawer();
	initFetchPhoneButton();
	initStatusCallingDropdown();
	initSendConnectionRequestLinkedInModal();
	initCandidateDashboardSearchInput();
	initToggleStatusHubspot();
	initCandidateDashboardSearchInput();

	const async_charts = $("#async-chart, #async-chart-2, #async-chart-3");

	async_charts.each((_,chart) => {
		const $chart = $(chart);

		const id = $chart.attr("id");
		const data = $chart.data("chart-data");
		const options = $chart.data("chart-options");
		const chartType = $chart.data("chart-type") || "ColumnChart";

		new Chartkick[chartType](id, data, options);

		initLitepicker();
	});
	loadPlatformChart();
	initSelectpicker();
	initClipCopy();
	//initFullThreadEmailResponses();
	initSubmitOnChange();
	addClickToAdCampaignTabs();
});

function loadPlatformChart() {
  const $canvas = $("#platform-chart");

	if($canvas.length > 0) {
		const reachData = $canvas.data("chart-reach-data");
		const resultData = $canvas.data("chart-result-data");

		new Chart($canvas[0] as HTMLCanvasElement, {
      type: 'bar',
      data: {
        datasets: [{
          data: Object.values(reachData.data),
          label: 'Reach',
          yAxisID: 'left-y-axis',
          backgroundColor: '#5a40b7'
        }, {
          data: Object.values(resultData.data),
          label: 'Results (Clicks)',
          yAxisID: 'right-y-axis',
          backgroundColor: '#77cacb'
        }],
        labels: Object.keys(reachData.data)
      },
      options: {
				scales: {
          'left-y-axis': {
            type: 'linear',
            position: 'left'
          },
          'right-y-axis': {
            type: 'linear',
            position: 'right'
          }
				}
      }
    });
	}
}

$(document).on("turbo:before-cache", () => {
	destroySummernote();
	destroySelectpicker();

	$("script[nonce]").each(function (index, element) {
		$(element).attr("nonce", element.nonce);
	});
});

function addClickToAdCampaignTabs() {
	$('.ad-campaign-tabs .tab').off('click').on('click', function() {
		const $container = $(".performance-metrics #render-async-stats")
		const url = $(this).data('url')
		const start_date = $('#litepicker').data('start-date')
		const end_date = $('#litepicker').data('end-date')

		$(this).addClass('active');
		$('.ad-campaign-tabs .tab').not(this).removeClass('active');
		$container.html("<div class='spinner-border text-primary'></div>")
		$container.attr('data-url', url)

		$.get(url, {start_date: start_date, end_date: end_date}, function(data) {
			$container.html(data)
		})
	});
}

function setBudgetFieldsVisibility() {
  $('#adset-campaign-id-dropdown').on('change', function () {
    const selectedOption = $(this).find('option:selected');
    const isCampaignBudget = selectedOption.data('campaign-budget');

    if (isCampaignBudget) {
      $('#adset-budget-fields').hide();
      $('#campaign-budget-set-msg').show();
    } else {
      $('#adset-budget-fields').show();
			$('#campaign-budget-set-msg').hide();
    }
  });
}
  
function initRenderCsStats() {
	$(".toggle-button").off("click").on("click", function () {
		if ($(this).find(".toggle").hasClass("collapsed")) {
			const $ele = $(this).parent().next().find('.render-cs-stats')
			$.get($ele.data("url"), function(data) {
				$ele.html(data)
			})
		}
	});
}

function initConfirmationPopup() {
  const $submitBtn = $("#submit-enqueue-candidates-btn");
  
  $submitBtn.off("click").on("click", function(e) {
    e.preventDefault();
    $submitBtn.prop("disabled", true);
    $submitBtn.html('<div class="d-flex align-items-center"><div class="spinner-border text-white" role="status"><span class="visually-hidden"></span></div>&nbsp; Enqueueing...</div>');
    
    $.ajax({
      url: $(this).closest("form.button_to").attr("action"),
      type: "POST",
      success: function(response) {
        $("#confirmation-popup").removeClass('active');
        $submitBtn.prop("disabled", false);
        $submitBtn.html('Yes, send to candidate list');

        if (response.success) {
          $("#success-popup").addClass('active');
          $("#success-popup .hint-text").text(response.message);
        } else {
          $("#fail-popup").addClass('active');
          $("#fail-popup .hint-text").html(response.message);

          if (response.reason === "no_permission") {
            $("#enqueue-batch-btns").addClass('hidden');
          } else {
            $("#enqueue-batch-btns").removeClass('hidden');
          }
        }
      }
    });
  });
}